import { IShipmentService } from '../@posturinn/client-react';
import {
	FETCH_POSTCODES_FAILED,
	FETCH_POSTCODES_FULFILLED,
	FETCH_POSTCODES_PENDING,
} from '../constants/actions/postCodesActions';
import { getCurrentLangPretty } from '../helpers/url/urlHelpers';
import { fetchPostboxesFailed } from './postboxesActions';

export const fetchPostCodesPending = () => ({
	type: FETCH_POSTCODES_PENDING,
	payload: null,
});

export const fetchPostCodesFulfilled = postCodes => ({
	type: FETCH_POSTCODES_FULFILLED,
	payload: {
		postCodes,
	},
});

export const fetchPostCodesFailed = error => ({
	type: FETCH_POSTCODES_FAILED,
	payload: {
		error,
	},
});

export const fetchPostCodes = () => {
	return async (dispatch, getState) => {
		dispatch(fetchPostCodesPending());
		const { injector } = getState().mobizReducer;
		const shipmentService: IShipmentService = injector.get(IShipmentService);

		try {
			shipmentService.getPostalCodes(getCurrentLangPretty()).subscribe({
				next: response => {
					const postcodes = [];
					for (let i = 0; response[i]; i++) {
						if (!['950', '951', '999'].includes(response[i].postalCode))
							postcodes.push({
								label: response[i].postalCode + ' ' + response[i].city,
								value: response[i].postalCode,
							});
					}
					// sort alphabetically by value
					postcodes.sort((a, b) => {
						if (a.value < b.value) return -1;
						if (a.value > b.value) return 1;
						return 0;
					});
					dispatch(fetchPostCodesFulfilled(postcodes));
				},
				error: error => {
					// dispatch(fetchPostboxesFailed(error));
					dispatch(fetchPostboxesFailed(JSON.stringify(error)));
					console.log(JSON.stringify(error));
				},
			});
		} catch (error) {
			dispatch(fetchPostCodesFailed(error));
		}
	};
};
